exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".darken-60[data-v-8dc56e80] {\n  background: rgba(0, 0, 0, 0.6);\n}", ""]);

// exports
